export default __webpack_public_path__ + "static/media/philosophies_of_freedom.582cf681.png";